import request from '../utils/request';

// 获取所有常用语列表
export const getPhraseList = () => {
  return request({
    url: '/api/manage/getPhraseList',
    method: 'get'
  });
};

// 新增常用语
export const addPhrase = (data) => {
  return request({
    url: '/api/manage/addPhrase',
    method: 'post',
    data
  });
};

// 更新常用语
export const updatePhrase = (data) => {
  return request({
    url: '/api/manage/updatePhrase',
    method: 'post',
    data
  });
};

// 删除常用语
export const deletePhrase = (id) => {
  return request({
    url: `/api/manage/deletePhrase?id=${id}`,
    method: 'post'
  });
};
